import { useQuery } from '@tanstack/react-query';
import settingApprovalApi from '@/features/public/settingApproval/api/settingApprovalApi.ts';
import { settingApprovalApiQueryKeys } from '@/features/public/settingApproval/api/settingApprovalApi.queryKeys.ts';

const useGetSettingApprovalPreview = (token: string | undefined) => {
  return useQuery({
    queryKey: settingApprovalApiQueryKeys.preview(token ?? ''),
    queryFn: () => settingApprovalApi.getPreview(token ?? ''),
    enabled: !!token,
    retry: false,
  });
};

export default useGetSettingApprovalPreview;
